import { globalURL } from "../../../app/constants/constants";

const initialState = {
    data: [],
    detail: null,
    isFetching: false,
    isFetchingDetail: false,
    isFetchingActions: false,
    error: false,
    process: "",
    showModal: false,
    name: "",
    code: "",
    name_helpertext: "",
    code_helpertext: "",
    images: [],
    images_helpertext: "",
    images_error: false,
    name_error: false,
    code_error: false,
   
}

export default function (state = initialState, action) {
    switch (action.type) {
        case "GET_ALL_COLORS":
            return {
                ...state,
                isFetching: true,
                error: false
            }
        case "FETCH_ALL_COLORS":
            return {
                ...state,
                isFetching: false,
                data: action.payload
            }
        case "ERROR_ALL_COLORS":
            return {
                ...state,
                isFetching: false,
                error: true
            }
        case "GET_INSERT_COLORS":
            return {
                ...state,
                isFetching: true,
                error: false
            }
        case "FETCH_INSERT_COLORS":
            var data = state.data;
            data.push(action.payload.data);
            return {
                ...state,
                isFetching: false,
                showModal: false,
                data: data,
                name: "",
                code: ""
            }
        case "ERROR_INSERT_COLORS":
            return {
                ...state,
                isFetching: false,
                error: true
            }
        case "TOGGLE_COLOR_MODAL":
            return {
                ...state,
                process: action.payload.process,
                showModal: action.payload.show,
                name: action.payload.show ? state.name : "",
                code: action.payload.show ? state.code : "",
                name_helpertext: "",
                code_helpertext: "",
                name_error: false,
                code_error: false,
                images : action.payload.process === "create" ? [] : state.images
            }
        case "SET_VALUE_COLOR":
            return {
                ...state,
                [action.payload.key]: action.payload.value,
                [action.payload.key + '_error']: false,
                [action.payload.key + '_helpertext']: ""
            }
        case "SET_VALUE_ERROR_COLOR":
            return {
                ...state,
                isFetching: false,
                [action.payload.key + '_error']: true,
                [action.payload.key + '_helpertext']: action.payload.helpertext
            }
        case "GET_DETAIL_COLOR":
            return {
                ...state,
                isFetchingDetail: true,
                isFetchingActions: false,
                error: false
            }
        case "FETCH_DETAIL_COLOR":
            return {
                ...state,
                isFetchingDetail: false,
                detail: action.payload.data,
                name: action.payload.data.colorName,
                code: action.payload.data.colorCode,
                isActive: action.payload.data.isActive,
                images : action.payload.data.image !== null ? [globalURL + "/images/" + action.payload.data.image.name] : []
            }
        case "ERROR_DETAIL_COLOR":
            return {
                ...state,
                isFetchingDetail: false,
                error: true
            }
        case "GET_UPDATE_COLOR":
            return {
                ...state,
                isFetchingActions: true,
                error: false
            }
        case "FETCH_UPDATE_COLOR":
            state.data[action.rowIndex] = action.payload.data;
            return {
                ...state,
                isFetchingActions: false,
                data: state.data,
                showModal: false,
                name: "",
                code: "",
                name_helpertext: "",
                code_helpertext: "",
                name_error: false,
                code_error: false
            }
        case "ERROR_UPDATE_COLOR":
            return {
                ...state,
                isFetchingActions: false,
                error: true
            }
        case "GET_DELETE_COLOR":
            return {
                ...state,
                isFetchingActions: true,
                error: false
            }
        case "FETCH_DELETE_COLOR":
            state.data.splice(action.rowIndex, 1);
            return {
                ...state,
                isFetchingActions: false,
                data: state.data,
                showModal: false
            }
        case "ERROR_DELETE_COLOR":
            return {
                ...state,
                isFetchingActions: false,
                error: true
            }
       
        default:
            return state
    }

}
